import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import BookingPage from "./pages/BookingPage";
import QuotePage from "./pages/QuotePage";
import ProductsPage from "./pages/ProductsPage";
import ContactPage from "./pages/ContactPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-ug-black flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/diensten" element={<ServicesPage />} />
            <Route path="/boeken" element={<BookingPage />} />
            <Route path="/offerte" element={<QuotePage />} />
            <Route path="/producten" element={<ProductsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster richColors position="top-right" />
        <div className="grain-overlay" />
      </div>
    </BrowserRouter>
  );
}

export default App;
